import { apiRequest, buildURL } from './commons/CommonService.Functions';

// models
import { Person } from '../models/Entities/Person/Person';
import {
  CreatePersonCommand,
  PersonFilter,
  UpdatePersonCommand
} from '../models/Entities/Person/PersonCommands';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'persons';

// Query string builder for the persons search endpoint
const BuildPersonsQueryString = (filter: PersonFilter | undefined): string => {
  const parameters = new URLSearchParams();

  parameters.append('PageNumber', String(filter?.PageNumber ?? 1));
  parameters.append('PageSize', String(filter?.PageSize ?? 1000));

  if (filter?.SearchText) parameters.append('SearchText', filter.SearchText);
  if (filter?.IdentifierTypeId !== undefined && filter?.IdentifierTypeId !== null)
    parameters.append('IdentifierTypeId', String(filter.IdentifierTypeId));
  if (filter?.Identifier) parameters.append('Identifier', filter.Identifier);

  return parameters.toString();
};

// Get all persons
export const GetPersons = async (
  token: string,
  filter?: PersonFilter
): Promise<Person[]> => {
  const requestUrl: string = `${BaseURL}?${BuildPersonsQueryString(filter)}`;
  return apiRequest<Person[]>(requestUrl, token, 'GetPersons');
};

// Get person by id
export const GetPersonById = async (
  token: string,
  personId: number
): Promise<Person> => {
  const requestUrl: string = buildURL(BaseURL, personId);
  return apiRequest<Person>(requestUrl, token, 'GetPersonById');
};

// Create person
export const CreatePerson = async (
  token: string,
  payload: CreatePersonCommand
): Promise<Person> => {
  return apiRequest<Person>(BaseURL, token, 'CreatePerson', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

// Update person
export const UpdatePerson = async (
  token: string,
  payload: UpdatePersonCommand
): Promise<Person> => {
  return apiRequest<Person>(BaseURL, token, 'UpdatePerson', {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
};

// Delete person
export const DeletePerson = async (
  token: string,
  personId: number
): Promise<number> => {
  const requestUrl: string = buildURL(BaseURL, personId);
  return apiRequest<number>(requestUrl, token, 'DeletePerson', {
    method: 'DELETE'
  });
};

// Fix person identifiers
export const FixPersonIdentifiers = async (token: string): Promise<boolean> => {
  const requestUrl: string = buildURL(BaseURL, 'fix-identifiers');
  return apiRequest<boolean>(requestUrl, token, 'FixPersonIdentifiers', {
    method: 'PUT'
  });
};
